var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import EdsExpansionPanel, { ExpansionPanelActions as EdsExpansionPanelActions, ExpansionPanelDetails as EdsExpansionPanelDetails, ExpansionPanelSummary as EdsExpansionPanelSummary } from '@hedtech/react-design-system/core/es/ExpansionPanel';
import Divider from '../Divider';
import Grid from '../Grid';
import Icon from '../Icon';
import Tokens from '../styles/Tokens';
import { createStyles, withStyles } from '../styles/withStyles';
const styles = createStyles({
    dividerError: {
        backgroundColor: Tokens.colorTextAlertError
    },
    dividerInfo: {
        backgroundColor: Tokens.colorTextAlertNeutral
    },
    dividerWarning: {
        backgroundColor: Tokens.colorTextAlertWarning
    },
    error: {
        alignItems: 'center',
        color: Tokens.colorTextAlertError,
        display: 'flex'
    },
    errorBackGround: {
        backgroundColor: Tokens.colorBackgroundAlertError,
        color: Tokens.colorTextAlertError
    },
    footer: {
        display: 'flex',
        justifyContent: 'flex-start!important'
    },
    headerGray: {
        backgroundColor: Tokens.colorBackgroundDefault
    },
    icon: {
        marginRight: Tokens.spacing30
    },
    info: {
        alignItems: 'center',
        color: Tokens.colorTextAlertNeutral,
        display: 'flex'
    },
    infoBackGround: {
        backgroundColor: Tokens.colorBackgroundAlertNeutral,
        color: Tokens.colorTextAlertNeutral
    },
    warning: {
        alignItems: 'center',
        color: Tokens.colorTextAlertWarning,
        display: 'flex'
    },
    warningBackGround: {
        backgroundColor: Tokens.colorBackgroundAlertWarning,
        color: Tokens.colorTextAlertWarning
    }
});
const ExpansionPanel = (props) => {
    const { applicationFormError, background, children, classes, expandIconProps, footer, header, id, leftIconDisplay, type } = props, rest = __rest(props, ["applicationFormError", "background", "children", "classes", "expandIconProps", "footer", "header", "id", "leftIconDisplay", "type"]);
    let classHeader;
    let classBody;
    let classDivider;
    switch (background) {
        case 'gray':
            classHeader = classes.headerGray;
            break;
    }
    switch (type) {
        case 'error':
            classHeader = classes.errorBackGround;
            classBody = classes.errorBackGround;
            classDivider = classes.dividerError;
            break;
        case 'info':
            classHeader = classes.infoBackGround;
            classBody = classes.infoBackGround;
            classDivider = classes.dividerInfo;
            break;
        case 'warning':
            classHeader = classes.warningBackGround;
            classBody = classes.warningBackGround;
            classDivider = classes.dividerWarning;
            break;
    }
    let panelHeader;
    if (header) {
        panelHeader = (React.createElement(EdsExpansionPanelSummary, { className: classHeader, expandIconProps: expandIconProps, id: `${id}_header`, leftIconDisplay: leftIconDisplay },
            React.createElement(Grid, { container: true },
                React.createElement(Grid, { item: true, xs: true }, applicationFormError ? (React.createElement("div", { className: classes.error },
                    React.createElement(Icon, { large: true, name: "warning", className: classes.icon }),
                    header))
                    : header))));
    }
    let panelBody;
    if (children) {
        panelBody = (React.createElement(EdsExpansionPanelDetails, { className: classBody, id: `${id}_detail` },
            React.createElement(Grid, { container: true },
                React.createElement(Grid, { item: true, xs: true },
                    type && (React.createElement(Divider, { className: classDivider, noMarginTop: true })),
                    children))));
    }
    let panelFooter;
    if (footer) {
        panelFooter = (React.createElement(EdsExpansionPanelActions, { className: classes.footer, id: `${id}_actions` }, footer));
    }
    return (React.createElement(EdsExpansionPanel, Object.assign({ id: id }, rest),
        panelHeader,
        panelBody,
        panelFooter));
};
export default withStyles(styles)(ExpansionPanel);
